(() => {
  // console.log(location)
  let path = location.pathname
  let params
  switch (path) {
    case '/':
    case '/learn/':
      params = {
        moduleCode: '/learn',
        moduleName: '首页'
      }
      break;
    case '/learn/search':
      params = {
        moduleCode: path,
        moduleName: '课程中心'
      }
      break;
    case '/learn/live':
      params = {
        moduleCode: path,
        moduleName: '直播中心'
      }
      break;
    case '/learn/videoreview':
      params = {
        moduleCode: path,
        moduleName: '在线课堂'
      }
      break;
  }
  if (params && Object.values(params).length) {
    API.reqModuleVisited({
      moduleCode: 'learn',
      moduleName: '首页'
    })
  }
})()